/**
 * ChatList - recent author chats. Tap a row (or its avatar) to open the chat.
 */
import { AuthorAvatar } from './AuthorAvatar.jsx';

function lastPreview(chat) {
  const m = chat.messages[chat.messages.length - 1];
  if (!m) return 'Say hi to the author';
  const body = m.kind === 'call' ? m.text : m.media && !m.text ? '📷 Media' : m.text;
  return `${m.from === 'me' ? 'You: ' : ''}${body}`;
}

export function ChatList({ chats, onOpen }) {
  const sorted = [...chats].sort((a, b) => b.lastAt - a.lastAt);
  return (
    <div class="chatlist">
      <header class="chatlist__header">Messages</header>
      {sorted.length === 0 ? (
        <div class="chatlist__empty">No chats yet</div>
      ) : (
        <ul class="chatlist__items">
          {sorted.map((c) => (
            <li
              key={c.id}
              class="chatlist__item"
              onClick={() => onOpen(c.id)}
            >
              <AuthorAvatar letter={c.letter} seed={c.id} size={48} />
              <div class="chatlist__meta">
                <span class="chatlist__name">{c.authorName}</span>
                <span class="chatlist__preview">
                  {c.pending?.typing ? 'typing…' : lastPreview(c)}
                </span>
              </div>
              {c.unread > 0 && <span class="chatlist__badge">{c.unread}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
